<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" (ngSubmit)="save()">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td style="width: 50%" class="margin-big plugin-table-cell">
              <h2>
                <span>{{ 'plugins.add-attachements.select-document' | translate }}</span>
              </h2>
            </td>
            <td style="width: 50%" colspan="2" class="margin-big plugin-table-cell th-plugin-line--value">
              <div class="ir-inputfile">
                <input
                  type="file"
                  name="file"
                  accept="image/*,application/pdf"
                  (change)="handleInputChange($event)"
                  multiple="true"
                  id="file-2"
                />
                <label for="file-2" class="ir-btn th-btn-modal">
                  <span>{{ 'plugins.add-attachements.browse' | translate }}</span>
                </label>
              </div>
            </td>
          </tr>
          <tr *ngFor="let asset of assets; let i = index">
            <td style="width: 50%" class="margin plugin-table-cell">
              <input name="assetFileTitle{{ i }}" class="ir-form-set" type="text" [(ngModel)]="assets[i].FileTitle" />
            </td>
            <td style="width: 50%" class="ir-txt--right">
              <span style="margin-left: 10px">{{ asset.Name }}</span>
            </td>
            <td class="th-plugin-line--remove ir-txt--right">
              <i style="margin-left: 10px" (click)="removeAsset(asset.AssetId)" class="material-icons">remove_circle</i>
            </td>
          </tr>
          <tr *ngFor="let item of files; let i = index">
            <td style="width: 50%" class="margin plugin-table-cell">
              <input name="fileTitle{{ i }}" class="ir-form-set" type="text" [(ngModel)]="files[i].fileTitle" />
            </td>
            <td style="width: 50%" class="ir-txt--right">
              <span style="margin-left: 10px">{{ item.name }}</span>
            </td>
            <td class="th-plugin-line--remove ir-txt--right">
              <i style="margin-left: 10px" (click)="removeFile(item.Id)" class="material-icons">remove_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
            >
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
